import React from "react";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import Badge from "Utils/Badge/Badge";
const alertaIcon = require("assets/img/icons/alerta_roja.png");

export const SobranteTurnoDetalle = ({ detalle }) => {
    const { sobrantes, haySobranteTurno, sobranteEnviadoBodega } = detalle;

    const cardClassName = "my-3 p-3 border-gray rounded-xl gap-1rem";

    if (!haySobranteTurno) {
        return (
            <div className={`${cardClassName} align-items-center`}>
                <div className="d-flex align-items-center gap-1rem justify-content-end">
                    <h5 className="mb-1 text-right text-nowrap">
                        ¿Hay sobrante de kg secos en el turno?
                    </h5>
                    <div style={{ minWidth: "200px" }}>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value="No"
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`formulario-fields-column ${cardClassName}`}>
            <div className="d-flex align-items-center gap-1rem justify-content-between mb-1">
                <h5 className="mb-0">Kg secos sobrantes</h5>
                <div
                    className="d-flex align-items-center gap-10"
                    style={{ height: "fit-content" }}
                >
                    <img
                        src={alertaIcon}
                        alt="Alerta"
                        className="title_img pb-1"
                    />
                    <label className="mb-0 pl-0 text-nowrap">
                        ¿Sobrantes enviados a bodega?
                    </label>
                    <Badge
                        text={!!sobranteEnviadoBodega ? "Sí" : "No"}
                        variant={
                            !!sobranteEnviadoBodega ? "success" : "warning"
                        }
                    />
                </div>
            </div>

            <div className="new-table-wrapper mt-1">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>Producto</th>
                            <th>Kg conforme</th>
                            <th>Kg no conforme</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sobrantes.map((item) => (
                            <tr key={item.orden_produccion_id}>
                                <td className="text-center text-nowrap">
                                    {item.producto_nombre}
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.kg_secos_sobrantes_conforme}
                                        decimals={3}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={
                                            item.kg_secos_sobrantes_no_conforme
                                        }
                                        decimals={3}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
